import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ROLE_ADMIN } from 'src/app/shared/constants/authorities.constants';
import { User } from './user.model';

@Injectable()
export class AuthenticationStore {
    private currentUser$ = new BehaviorSubject<User>(undefined); // undefined => on ne sait pas encore si l'utilisateur est loggué ou non
    private realUser$ = new BehaviorSubject<User>(undefined); // Real user when using impersonation

    setCurrentUser = (currentUser: User) => this.currentUser$.next(currentUser);
    setRealUser = (user: User) => this.realUser$.next(user);

    unsetCurrentUser = () => this.currentUser$.next(null); // null => on sait que l'utilisateur n'est pas loggué

    getAuthenticationState(): Observable<boolean> {
        return this.currentUser$.asObservable().pipe(
            filter((user) => user !== undefined),
            map((user) => user != null),
        );
    }

    getCurrentUser = (): Observable<User> => this.currentUser$.pipe(filter((user) => user !== undefined));
    getCurrentUserSnapshot = (): User => this.currentUser$.getValue();

    getRealUser = (): Observable<User> => this.realUser$.asObservable();
    getRealUserSnapshot = (): User => this.realUser$.getValue();

    isAdmin = (): Observable<boolean> =>
        this.currentUser$.pipe(
            filter((user) => user !== undefined),
            map((user) => (user ? user.authorities.includes(ROLE_ADMIN) : false)),
        );

    getCurrentUserFullName(): string {
        const user = this.getCurrentUserSnapshot();
        return [user.firstName, user.lastName].filter(Boolean).join(' ');
    }
}
